import * as React from 'react';
import BaggageIconBase from '@websky/core/src/Baggage/Baggage/components/BaggageIcon/BaggageIcon';
import { BaggageSize } from '@websky/core/src/Baggage/Baggage/types';
import { CarryOnExcessLarge, CarryOnExcessSmall, CarryOnSmall, LargeBaggageIcon, SmallBaggageIcon } from './icons';
import { BaggageType } from '@websky/graphql';
const IconsMap = new Map([
    [
        BaggageType.CheckedBaggage,
        new Map([
            [BaggageSize.small, SmallBaggageIcon],
            [BaggageSize.middle, LargeBaggageIcon],
            [BaggageSize.large, LargeBaggageIcon]
        ])
    ],
    [
        BaggageType.CarryOn,
        new Map([
            [BaggageSize.small, CarryOnSmall],
            [BaggageSize.large, SmallBaggageIcon]
        ])
    ],
    [
        BaggageType.HandLuggageExcess,
        new Map([
            [BaggageSize.small, CarryOnExcessSmall],
            [BaggageSize.large, CarryOnExcessLarge]
        ])
    ]
]);
const BaggageIcon = props => {
    return React.createElement(BaggageIconBase, Object.assign({}, props, { iconsMap: IconsMap }));
};
export default BaggageIcon;
